import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  CalendarEvent,
  CalendarEventTimesChangedEvent,
  CalendarView,
} from 'angular-calendar';
import * as fromScheduleDashboardSelector from '../../../../store/schedule-dashboard/schedule-dashboard.selectors';
import { combineLatest, Observable, Subject, of } from 'rxjs';
import { ScheduleDashboardState } from '../../../../store/schedule-dashboard/schedule-dashboard.reducer';
import { AppointmentType, Department, IAppointment, IEmployee, IGeneralSettings, IPartsAppointment, IPartsVehicle, IServiceAppointment, ITeam, IVehicle, TransportationType } from '@signal/asp-data-commons';
import { DateTime } from 'luxon';
import { SettingsState } from '../../../../store/settings/settings.reducer';
import * as fromSettingSelector from '../../../../store/settings/settings.selectors';
import * as fromTeamsSelectors from '../../../../store/team/team.selectors';
import { MatDialog } from '@angular/material/dialog';
import { AppointmentSummaryDialogComponent } from '../appointment-summary-dialog/appointment-summary-dialog.component';
import { TeamState } from 'src/app/modules/store/team/team.reducer';
import * as fromScheduleDashboardActions from '../../../../store/schedule-dashboard/schedule-dashboard.action';
import { ConfirmDialogComponent } from '../../confirm-dialog/confirm-dialog.component';
import { AppointmentService } from '../../../services/appointment.service';
import * as util from '../../../../shared/services/util.service';
import { SubscriptionList } from '../../../models/asp.types';
import { DatePipe } from '@angular/common';
import {TranslateService} from '@ngx-translate/core';
import { cacheLimitedStartDate, titleCase } from '../../../../shared/services/util.service';
import { AppointmentBookingSource, ConfirmStatus } from '@signal/asp-data-commons/lib/enums/enum';
import { SalesAppointmentState } from '../../../../store/sales-appointment/sales-appointment.reducer';
import { ServiceAppointmentState } from 'src/app/modules/store/service-appointment/service-appointment.reducer';
import * as fromSalesAction from '../../../../store/sales-appointment/sales-appointment.actions';
import * as fromServiceActions from '../../../../store/service-appointment/service-appointment.actions';
import { VehiclesState } from 'src/app/modules/store/vehicle/vehicle.reducer';
import { selectAllVehiclesFromInventory, selectVehiclesLoaded } from '../../../../store/vehicle/vehicle.selectors';
import { LoadPendingAppointments } from 'src/app/modules/store/bdcdashboard/bdcdashboard.actions';
import { BdcDashboardState } from 'src/app/modules/store/bdcdashboard/bdcdashboard.reducer';
import { getDeletePendingForTestdrive } from 'src/app/modules/store/sales-appointment/sales-appointment.adapter';

@Component({
  selector: 'app-appointment-dispatch-view',
  templateUrl: './appointment-dispatch-view.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./appointment-dispatch-view.component.scss']
})
export class AppointmentDispatchViewComponent implements OnInit, OnChanges, OnDestroy {
  // Generated by Copilot- Start
  readonly minimumDispatchCardWidth = 200;
  readonly maximumDispatchCardWidth = 280;
  private readonly dispatchNameCharWidthPx = 8;
  // Generated by Copilot- End
  view: CalendarView = CalendarView.Day;
  appointmentsForDay$: Observable<IAppointment[]>;
  private subs: SubscriptionList = {};
  viewDate: Date = new Date();
  @Input() zoomVal: number;
  @Input() department : Department;
  @Input() filterValue: any;
  @Output() emitAppointmentDetails: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Input() selectedDate: any;
  isSelectedDateWithinCacheDate:boolean = false;
  events: CalendarEvent[] = [];
  appointmentsFiltered: any[] = [];

  refresh: Subject<any> = new Subject();
  isApptLoading$: Observable<boolean>;
  isTeamsLoading$: Observable<boolean>;
  isSettingsLoading$: Observable<boolean>;
  @Output() advisorListChange: EventEmitter<IEmployee[]> = new EventEmitter<IEmployee[]>();
  dealerSettings$: Observable<IGeneralSettings>;
  teams$: Observable<ITeam[]>;
  teamList: ITeam[] = [];
  // testdriveSalesApptDuration: number = 60;
  // deliverySalesApptDuration: number = 60;
  hourSplit: number = 2;
  selectedTeamFilter: string = 'ALL';
  selectedAppointmentTypeFilter:string =  'All Types';
  dayStartHour: number = 1;
  dayEndHour: number = 23;
  private dealerSettings: IGeneralSettings;
  isRescheduleDialogOpened:boolean = false;
  isCrmIntegrated:boolean;
  isDmsIntegrated:boolean;
  salesApptColorObj = {
    "Test Drive": "#AED5EB",
    "Delivery": "#C9FFF5",
    "Learning": "#F4B8B2",
    "Vehicle Inquiry": "#FFDCA3",
  }
  salesApptTimeDuration = {
    "Test Drive": 60,
    "Delivery": 60,
    "Learning": 60,
    "Vehicle Inquiry": 60
  }
  isSlotLoading$: Observable<boolean>;
  dateFormat : string = 'yyyy-MM-dd';
  aspModalContainer : string = 'asp-modal-container';
  isVehiclesLoading$: Observable<boolean>;
  allInventoryVehicles : any[];

  constructor(public readonly dialog: MatDialog, private readonly appointmentService: AppointmentService,
     private readonly teamsState: Store<TeamState>, private readonly scheduleDashboardState: Store<ScheduleDashboardState>, 
     private readonly settingsState: Store<SettingsState>,
    private readonly translate : TranslateService,
    private readonly salesAppointmentState: Store<SalesAppointmentState>,
    private readonly serviceAppointmentState: Store<ServiceAppointmentState>,
    private readonly vehiclesState : Store<VehiclesState>,
    private readonly bdcDashboardStore: Store<BdcDashboardState>
    ) { }

  ngOnInit() {
    this.isCrmIntegrated = util.isAspCrmIntegrationEnabled;
    this.isDmsIntegrated = util.isAspDmsIntegrationEnabled;
    this.dealerSettings$ = this.settingsState.select(fromSettingSelector.selectSettings);
    this.teams$ = this.teamsState.select(fromTeamsSelectors.selectTeams);
    if (this.department === Department.SALES) {
      this.isVehiclesLoading$ = this.vehiclesState.select(selectVehiclesLoaded);
      this.subs.vehicleSub = combineLatest([this.vehiclesState.select(selectVehiclesLoaded),
      this.vehiclesState.select(selectAllVehiclesFromInventory), this.dealerSettings$]).subscribe(([loaded, allVehicles, settings]) => {
        if (loaded && allVehicles && settings && !!settings.time) {
          this.dealerSettings = settings;
          this.getHourInfo(settings);
          this.allInventoryVehicles = allVehicles?.length ? allVehicles : [];
          this.convertApptToEvents();
        }
      })
    } else if (this.department === Department.PARTS) {
      this.isVehiclesLoading$ = of(true);
      this.isTeamsLoading$ = of(true);
      this.allInventoryVehicles = [];
      this.subs.partsSettingsSub = this.dealerSettings$.subscribe(settings => {
        if (settings && !!settings.time) {
          this.dealerSettings = settings;
          this.getHourInfo(settings);
          this.convertApptToEvents();
        }
      });
    } else {
      this.isVehiclesLoading$ = of(true);
    }
    this.subs.dealerSettingSub = this.dealerSettings$.subscribe(data => {
      if (data && !!data.time) {
        this.dealerSettings = data;
        this.getHourInfo(data);
      }
    });
    this.isApptLoading$ = this.scheduleDashboardState.select(fromScheduleDashboardSelector.selectScheduleDashboardLoading);
    this.isSlotLoading$ = this.scheduleDashboardState.select(fromScheduleDashboardSelector.selectScheduleDashboardSlotLoading);
    if (this.department === Department.SERVICE) {
      this.subs.serviceCombine = combineLatest([
        this.teamsState.select(fromTeamsSelectors.selectTeamsLoaded),
        this.isApptLoading$
      ]).subscribe(([teams, appointments]) =>{
         if(teams && appointments){
           this.subs.teamSub = this.teams$.subscribe(teamList => {
           this.teamList = teamList;
          });
          this.convertApptToEvents();
        }
       })
      } else {
      this.isTeamsLoading$ = of(true);
    }
    this.isSettingsLoading$ = this.settingsState.select(fromSettingSelector.selectSettingsLoaded);
  }

  getHourInfo(data) {
    const duration = data.time.slotDuration;
    this.salesApptTimeDuration['Test Drive'] = data.time.testdriveAppointmentDuration;
    this.salesApptTimeDuration.Delivery =  data.time.deliveryAppointmentDuration + data.time.deliveryApptDuration;
    this.salesApptTimeDuration['Learning'] = data.time.techcenterAppointmentDuration;
    this.salesApptTimeDuration['Vehicle Inquiry'] =  data.time.vehicleInquiryDuration;
    //delivery chnage above line
    this.hourSplit = 60 / duration;
    if (duration === 45) {
      this.hourSplit = 4;
    } else if (duration === 60) {
      this.hourSplit = 2;
    }
    const selectedDay = this.getSelectedWeekdayShort();
    const operationHr = data.time.hoursOfOperation
      ?.find(x => x?.day?.toLowerCase() === selectedDay.toLowerCase())?.operation;
    if (!operationHr) {
      return;
    }
    if (operationHr.split('-').length === 2) {
      this.dayStartHour = Number.parseInt(DateTime.fromFormat(operationHr.split('-')[0].trim(), 'h:mm a').toFormat("H"), 10);
      this.dayEndHour = Number.parseInt(DateTime.fromFormat(operationHr.split('-')[1].trim(), 'h:mm a').toFormat("H"), 10);
    }
  }

  private getSelectedWeekdayShort(): string {
    if (this.selectedDate instanceof Date) {
      return DateTime.fromJSDate(this.selectedDate).weekdayShort || DateTime.now().weekdayShort;
    }

    return DateTime.now().weekdayShort;
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.hasOwnProperty('zoomVal')) {
      this.hourSplit = changes.zoomVal.currentValue;
    }

    if (changes.hasOwnProperty('filterValue')) {
      if (changes.filterValue.currentValue !== changes.filterValue.previousValue) {
        this.selectedTeamFilter = changes.filterValue.currentValue.teamId;
        this.selectedAppointmentTypeFilter = changes.filterValue.currentValue.appointmentType;    
        if(this.department === Department.SERVICE)
        {
          this.subs.teamsAndAppts = combineLatest([
            this.isTeamsLoading$ = this.teamsState.select(fromTeamsSelectors.selectTeamsLoaded),
            this.scheduleDashboardState.select(fromScheduleDashboardSelector.selectScheduleDashboardLoading)
          ]).subscribe(([teams, appointments]) =>{
            if(teams && appointments)
            {
              this.convertApptToEvents();
              this.isVehiclesLoading$ = new Observable((observer) => {
                observer.next(true);
                observer.complete();
              })
            }
          })
      }
        else {
          if (this.department === Department.PARTS) {
            this.convertApptToEvents();
            this.isTeamsLoading$ = of(true);
            return;
          }
          this.subs.vehicleSub = combineLatest([this.vehiclesState.select(selectVehiclesLoaded),
          this.vehiclesState.select(selectAllVehiclesFromInventory)]).subscribe(([loaded, allVehicles]) => {
            if (loaded && allVehicles) {
              this.allInventoryVehicles = allVehicles?.length ? allVehicles : [];
              this.convertApptToEvents();
            }
          })
          this.isTeamsLoading$ = new Observable((observer) => {
            observer.next(true);
            observer.complete();
          })
        }
      }
    }
    if(changes.hasOwnProperty('selectedDate')) {
      if(changes.selectedDate.currentValue < new Date(cacheLimitedStartDate.plus({days:-1}).toFormat(this.dateFormat))){
        this.isSelectedDateWithinCacheDate = true;
      }else{
        this.isSelectedDateWithinCacheDate = false;
      }

      if (this.dealerSettings?.time) {
        this.getHourInfo(this.dealerSettings);
      }
    }
  }

  titleCase(str: string) {
    return str.toLowerCase().split(' ').map(function(word) {
      return word.replace(word[0], word[0].toUpperCase());
    }).join(' ');
  }

  getFormatedDate(date: Date, format: string) {
    const datePipe = new DatePipe('en-US');
    return datePipe.transform(date, format);
  }

  getTxmTeamId() {
    return this.teamList.find(t => t.id === this.selectedTeamFilter && t.name === 'TXM')
  }

  getTeamColor(grpsInAppt, teamColors) {
    if (!grpsInAppt?.length) {
      return;
    }

    grpsInAppt.forEach((x) => {
      const isServiceDepartment = this.department === Department.SERVICE;
      const isPartsDepartment = this.department === Department.PARTS;
      const appointmentType = (this.department === Department.SALES || isPartsDepartment) ? x.split('&')[1] : x;
      const colorObj = {
        primary: '#FFFFFF',
        secondary: isServiceDepartment
          ? this.teamList.find(team => team.id === x)?.teamColor
          : this.salesApptColorObj[appointmentType] ?? '#D1E8FF'
      };

      if (teamColors.findIndex(y => y.id === x) === -1) {
        teamColors.push({ id: x, color: colorObj });
      }
    });
  }

  getApptForService(appointments) {
    if (this.selectedTeamFilter !== 'ALL' && this.selectedTeamFilter !== 'OTHER') {
      if (this.getTxmTeamId()) {
        this.appointmentsFiltered = appointments.filter(a => a.isTxm);
        return;
      }

      this.appointmentsFiltered = appointments.filter(x =>
        this.teamList.find(y => y.employeeIds?.includes(x.advisor.id) && !x.isTxm)?.id === this.selectedTeamFilter
      );
      return;
    }

    if (this.selectedTeamFilter === 'OTHER') {
      this.appointmentsFiltered = appointments.filter(x =>
        this.teamList.find(y => y.employeeIds?.includes(x.advisor.id) && x.advisor.isTxm) && !x.isTxm
      );
      return;
    }

    this.appointmentsFiltered = appointments;
  }

  convertApptToEvents() {
    this.appointmentsForDay$ = this.scheduleDashboardState.select(
      fromScheduleDashboardSelector.selectScheduleDashboardAppointmentsForDay, { department: this.department.toLowerCase() });
    this.subs.appointmentListSub = this.appointmentsForDay$.subscribe(appointments => {
      this.events = [];
      const appointmentList = [];
      if (appointments?.length > 0) {
        const grpsInAppt = (this.department === Department.SERVICE) ? this.teamList.map(x => x.id) : 
        appointments.map(x =>`${x.advisorId}&${x.appointmentType}`);
        const teamColors = [];
        if(this.department === Department.SERVICE){
          this.getApptForService(appointments)
        }else{
          this.appointmentsFiltered = this.selectedAppointmentTypeFilter === 'All Types' ? appointments :
           (appointments.filter(appt=> appt.appointmentType === this.selectedAppointmentTypeFilter));
        }
        this.appointmentsFiltered.forEach(appt => {  
          this.getTeamColor(grpsInAppt,teamColors)

          const defaultColor = {
            primary: '#FFFFFF',
            secondary: '#D1E8FF',
          };
            const appointment = appt as IServiceAppointment | IPartsAppointment;
            const serviceAppointment = appt.appointmentType === AppointmentType.SERVICE ? appointment as IServiceAppointment : undefined;
            const partsVehicle = appt.appointmentType === AppointmentType.PARTS ? appointment.vehicle as IPartsVehicle : undefined;
            const syncAppointment = appointment as { syncStatus?: string; syncError?: string };
            const isDraggable =  (this.getFormatedDate(DateTime.fromFormat(appt.appointmentStartDate, this.dateFormat).toJSDate(),this.dateFormat) >= 
            this.getFormatedDate(DateTime.now().toJSDate(),this.dateFormat)) && (this.isDragAccessAllowed(appointment.appointmentType)) ? true : false;
            let makeModelYear = partsVehicle
              ? [partsVehicle.year, partsVehicle.make, partsVehicle.model].filter(Boolean).join(' ').trim()
              : this.getVehicleDisplayText(appointment?.vehicle);
            makeModelYear = makeModelYear || appointment?.vehicle?.vin || '';
            if (appt.appointmentType === AppointmentType.PARTS && !makeModelYear) {
              makeModelYear = 'NA';
            }
            const partsOrderRef = partsVehicle?.orderRefNumber || 'NA';
            const partsDealerOrder = partsVehicle?.dealerOrderNumber || 'NA';
            let vehicleInquiryData = '';
            if(appt.appointmentType===AppointmentType.VEHICLE_INQUIRY)
            {
              makeModelYear =this.translate.instant('vehicleInquiry.vehiclesOfInterest');
              if(!appt?.vehiclesOfInterest?.length && !appt?.vehicleType)
              {
                vehicleInquiryData = this.translate.instant('vehicleInquiry.notSpecified')
                makeModelYear += ':'+ vehicleInquiryData;
              }
              else{
                const vehicleTypes=util.getVehicleTypeTraslation(appt?.vehicleType,this.translate);
                const vehicleDisplayText=util.getVehicleDisplayTextForEnquiryAppt(appt?.vehiclesOfInterest,this.translate);
                vehicleInquiryData = `${vehicleTypes} ${((vehicleTypes && vehicleDisplayText) ? "," : '')} ${vehicleDisplayText}`;
                makeModelYear += `: ${vehicleInquiryData}`;
              }
            }
            const laborHrs = this.getEventDurationHours(appt.appointmentType, serviceAppointment?.totalLaborHours || 0);
            const safeLuxonStart = this.getEventStartDateTime(appointment);
            const luxonEnd = safeLuxonStart.plus({ hour: laborHrs });
            const color = this.department === Department.SERVICE ? appt.isTxm ? {"primary": "#FFFFFF","secondary": "#B7FFB7"} : 
            appt.appointmentBookingSource !== AppointmentBookingSource.ONEAPP_SP ? (teamColors.find(x => x.id === (this.teamList.find(x => x.employeeIds?.includes(appt.advisor.id) && !appt.advisor.isTxm)?.id))?.color) : 
            (teamColors.find(x => x.id === (this.teamList.find(x => x.employeeIds?.includes(appt?.advisor?.id) && !appt?.advisor?.isTxm)?.id))?.color) :
            (teamColors.find(x => x.id === `${appt.advisorId}&${appt.appointmentType}`)?.color) || defaultColor;
            const isIntegrationEnabled = (this.department === Department.SERVICE && this.isDmsIntegrated)
              || (this.department === Department.SALES && this.isCrmIntegrated);
            let status: string;
            if (isIntegrationEnabled) {
              if (syncAppointment.syncStatus === 'SYNC_FAILURE') {
                status = 'Sync Failed <br>Reason : ' + syncAppointment.syncError;
              } else if (syncAppointment.syncStatus === 'SYNC_REQUESTED') {
                status = 'Sync Initiated';
              } else if (syncAppointment.syncStatus === 'SYNC_COMPLETED') {
                status = 'Sync Successful';
              } else {
                status = 'Sync Not Applicable';
              }
            } else {
              status = this.department === Department.SERVICE
                ? this.translate.instant('otherTexts.notSubscribedToDmsIntegration')
                : this.translate.instant('otherTexts.notSubscribedToCrmIntegration');
            }
            const deletePending = getDeletePendingForTestdrive(appointment, this.allInventoryVehicles);
            /* check if advisor is available */
            const apptAdvisor= appointment.appointmentBookingSource !== AppointmentBookingSource.ONEAPP_SP ? appointment.advisor?.displayName : appointment?.advisor?.displayName;
            const advisorLabel = (this.department === Department.SALES) ? 'serviceSchedule.consultant' : 'serviceSchedule.advisor';
            
            const calendarEvent: CalendarEvent =
            {
              title: `
                <div class="content">
                  <div class="subContent">
                    <span class="fullName"><b>${this.getCustomerDisplayName(appointment)} </b> </span> 
                    <span class="transportationType"> ${this.getTranslationForTransportation(appointment.transportationTypeCode)} </span> 
                  </div>
                  ${appt.appointmentType !== AppointmentType.VEHICLE_INQUIRY ? `<b>Vehicle</b> : ${makeModelYear}` : `<b>${this.translate.instant('vehicleInquiry.vehiclesOfInterest')}</b> : ${vehicleInquiryData}`} <br>
                  ${appt.appointmentType === AppointmentType.PARTS ? `<b>${this.translate.instant('parts.orderRef')}</b> : ${partsOrderRef}<br>
                  <b>${this.translate.instant('parts.dealerOrder')}</b> : ${partsDealerOrder}<br>` : ''}
                  <b>${this.translate.instant(advisorLabel)}</b> : ${apptAdvisor || 'NA'}<br>
                  ${this.department === Department.SALES ? `<b>${this.translate.instant('pendingAppointments.appointmentType')}</b> : ${appointment.appointmentType} <br>`: ""}
                  ${this.department === Department.SERVICE ? `<b>${this.translate.instant('serviceSchedule.serviceDetails')}</b> : ${this.getDisplayNameOfServiceDetails(appointment)} <br>`: ""}
                  <b>${this.translate.instant('serviceSchedule.syncStatus')}</b> : ${status}
                  ${deletePending ? '<br>' + this.translate.instant('vehicleManagement.vehicleUnavailable')+' : ' + 
                  this.translate.instant('vehicleManagement.vehicleIsUnavailableForTestDrive') : ''}
                </div>
              `,
              start: safeLuxonStart.toJSDate(),
              end: luxonEnd.toJSDate(),
              draggable: isDraggable,
              color: color,
              meta: { ...appointment, makeModelYear, deletePending },
            };
            this.events.push(calendarEvent);
           const teamNameList = this.teamList.map(team =>{
              if(team.employeeIds?.find(empId=> empId === appointment.advisor.id)){
                return team.name;
              }
            }).filter(function(item){
              return typeof item ==='string';
          });
            const teamName = teamNameList.length > 0 ? teamNameList[0] : '';
            appointmentList.push({ ...appointment, teamName:teamName , estimatedDuration:(this.department === Department.SERVICE) ? laborHrs : this.salesApptTimeDuration[appt.appointmentType]/60});
        });
        this.emitAppointmentDetails.emit(appointmentList);
        this.events = this.events.sort((x, y) => {
          const startDelta = x.start.getTime() - y.start.getTime();

          if (startDelta !== 0) {
            return startDelta;
          }

          return y.end.getTime() - x.end.getTime();
        });
        this.events.forEach((evt, i) => {
          const concurrentEvents = this.events.slice(0, i).filter(
            other => other.start.getTime() < evt.end.getTime()
              && other.end.getTime() > evt.start.getTime()
          );
          const usedLanes = concurrentEvents
            .map(e => e.meta?.overlapLaneIndex as number)
            .filter(l => l !== undefined && l >= 0);
          let lane = 0;
          while (usedLanes.includes(lane)) {
            lane++;
          }
          evt.meta = { ...evt.meta, overlapLaneIndex: lane };
        });
      }
      const advisorList = appointments?.map(x => x.appointmentBookingSource !== AppointmentBookingSource.ONEAPP_SP ? x.advisor : x?.advisor) || [];
      this.advisorListChange.emit(advisorList);
    })
  }

  private getEventDurationHours(appointmentType: string, totalLaborHours: number | string): number {
    if (this.department === Department.SERVICE) {
      const serviceDurationHours = Number(totalLaborHours);
      return Number.isFinite(serviceDurationHours) && serviceDurationHours > 0 ? serviceDurationHours : 1;
    }

    const configuredDurationMins = Number(this.salesApptTimeDuration?.[appointmentType]);
    const safeDurationMins = Number.isFinite(configuredDurationMins) && configuredDurationMins > 0 ? configuredDurationMins : 60;
    return safeDurationMins / 60;
  }

  private getEventStartDateTime(appointment: { timeSlotId?: string; appointmentTimeUTC?: string }): DateTime {
    const eventDate = DateTime.fromJSDate(this.viewDate).toFormat(this.dateFormat);
    const slotValue = appointment.timeSlotId || '';
    const fallbackTimeValue = appointment.appointmentTimeUTC || '';

    if (!slotValue && !fallbackTimeValue) {
      return DateTime.fromISO(`${eventDate}T00:00:00`);
    }

    const slotStart = DateTime.fromFormat(`${eventDate} ${slotValue}`, 'yyyy-MM-dd h:mm a');

    if (slotStart.isValid) {
      return slotStart;
    }

    const fallbackStart = DateTime.fromFormat(`${eventDate} ${fallbackTimeValue}`, 'yyyy-MM-dd HH:mm');

    if (fallbackStart.isValid) {
      return fallbackStart;
    }

    return DateTime.fromISO(`${eventDate}T00:00:00`);
  }

  private getVehicleDisplayText(vehicle?: IVehicle | IPartsVehicle): string {
    if (!vehicle) {
      return '';
    }

    if (vehicle.year && vehicle.model) {
      return util.getMakeModelYearText(vehicle as IVehicle);
    }

    return vehicle.vin || '';
  }

  getDisplayNameOfServiceDetails(appointment) {
    if(!appointment.serviceRequests?.length) {
      return "";
    }
    const displayNames = [];
    appointment.serviceRequests.forEach(serviceRequest=> {
      displayNames.push((serviceRequest?.details?.displayName ? serviceRequest.details.displayName : serviceRequest?.details?.description ? 
        serviceRequest.details.description : serviceRequest?.details?.dmsDescription) || '');
    });
    return displayNames.join(', ');
  }

  getRandomColor() {
    var letters = 'BCDEF'.split('');
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(util.getRandomValue() * letters.length)];
    }
    return color;
  }
  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    const oldStartTime = DateTime.fromISO(event.start.toISOString()).toFormat('hh:mm a');
    const newTime = DateTime.fromISO(newStart.toISOString()).toFormat('hh:mm a');
    if(oldStartTime !== newTime){
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '400px',
        height: '220px',
        data: {
          popupTitle: 'serviceSchedule.rescheduleAppointment',
          popupBodyText: this.translate.instant('serviceSchedule.areYouSureYouWantToRescheduleThisAppointmentToNewTime?', {newTime})
        },
        panelClass: this.aspModalContainer
      });
      this.subs.dialog = dialogRef.afterClosed().subscribe((result) => {
        if (result.action === 'confirm') {
          let appointment = {} as IAppointment;
          appointment = this.appointmentsFiltered.find(x => x.appointmentId === event.meta.appointmentId);
          const advisorAvatar = appointment.appointmentBookingSource !== AppointmentBookingSource.ONEAPP_SP ? appointment.advisor.avatar : appointment?.advisor?.avatar;
          if(advisorAvatar){
            const { avatar,...advisor } = appointment.advisor;
            appointment = {...appointment,advisor : advisor};
          }
          if(appointment?.vehicle?.imageUrl){
            const { imageUrl,...vehicle } = appointment.vehicle;
            appointment = {...appointment,vehicle : vehicle};
          }
          this.scheduleDashboardState.dispatch(new fromScheduleDashboardActions.UpdateAppointmentTime({ appointment: appointment, newTimeSlot: DateTime.fromISO(newStart.toISOString()).toFormat('hh:mm a') }))
          event.start = newStart;
          event.end = newEnd;
          event.meta.syncStatus = "SYNC_REQUESTED";
          this.refresh.next();
        }
      });
    }
  }




  eventClicked({ event }: { event: CalendarEvent }): void {
    this.subs.appointmentLoadSub = this.appointmentService
      .get(event.meta.appointmentType, event.meta.appointmentId).subscribe(resp => {
        if (resp.data && !this.isRescheduleDialogOpened) {
          this.isRescheduleDialogOpened = true;
          const dialogRef = this.dialog.open(AppointmentSummaryDialogComponent, {
            data: {...resp.data, department: this.department, allInventoryVehicles: this.allInventoryVehicles}, 
            panelClass: 'appointment-summary-dialog'
          });


          this.subs.confirmDialog = dialogRef.afterClosed().subscribe(result => {
            this.isRescheduleDialogOpened = false;
            if (result === 'cancel') {
              const dialogRef2 = this.dialog.open(ConfirmDialogComponent, {
                width: '400px',
                height: '220px',
                data: {
                  popupTitle: 'serviceSchedule.cancelAppointment',
                  popupBodyText: 'serviceSchedule.areYouSureYouWantToCancelThisAppointment'
                },
                panelClass: this.aspModalContainer
              });

              this.subs.dialog2 = dialogRef2.afterClosed().subscribe((result) => {
                if (result.action === 'confirm') {
                  this.subs.cancel = this.appointmentService.cancel(event.meta).subscribe((data) => {
                    if(event.meta?.deletePending) {
                      this.bdcDashboardStore.dispatch(new LoadPendingAppointments({type: 'deletePending'}));
                    }
                    const index = this.events.findIndex(x => x === event);
                    this.events.splice(index, 1);
                    this.refresh.next();
                  });
                }
              });
            }else if (result === 'confirm') {
              const dialogRef2 = this.dialog.open(ConfirmDialogComponent, {
                width: '400px',
                height: '220px',
                data: {
                  popupTitle: 'serviceSchedule.confirmAppointment',
                  popupBodyText: 'serviceSchedule.areYouSureYouWantToConfirmThisAppointment'
                },
                panelClass: this.aspModalContainer
              });

              this.subs.confirmDialogRef = dialogRef2.afterClosed().subscribe((result) => {
                if (result.action === 'confirm') {
                  const data = JSON.parse(JSON.stringify(event.meta));
                  data.confirmAppointmentStatus = ConfirmStatus.CONFIRMED;
                  this.subs.confirmAppt = this.appointmentService.confirmAppointment(data).subscribe((data) => {
                   
                  });
                }
              });
            }
            // if(event?.meta?.appointmentType === AppointmentType.TEST_DRIVE)
            // this.salesAppointmentState.dispatch(new fromSalesAction.ResetSalesAppointmentForm())
            this.salesAppointmentState.dispatch(new fromSalesAction.ResetSalesAppointmentState());

            this.serviceAppointmentState.dispatch(new fromServiceActions.ResetServiceAppointmentState());
          });
        }
      })
  }

  resyncAppointment(appointment) {
  }

  getTranslationForTransportation(value){
    if(!value){
      value = TransportationType.WAITER;
    }
    /* transportation type code for which we have translation*/
    const transportationTypeCode = ["drop off","drop-off","remote","shuttle","wait","waiter","loan","loaner","rental","dealer"];
    if(this.department === Department.SERVICE) {
      const code = titleCase(value).replace(' ', '');
      return value && (transportationTypeCode.includes(value.toLowerCase()))? this.translate.instant(`service.${code}`) : value;
    } else if(value === TransportationType.REMOTE) {
        return this.translate.instant(`common.${titleCase(value)}`);
      } else {
        return value && (transportationTypeCode.includes(value.toLowerCase()))? this.translate.instant(`service.${titleCase(value)}`) : value;
    }
  }

  hasTradeInIndicator(event: CalendarEvent): boolean {
    const appointmentType = event?.meta?.appointmentType;
    const hasAllowedType = appointmentType === AppointmentType.TEST_DRIVE
      || appointmentType === AppointmentType.DELIVERY
      || appointmentType === AppointmentType.VEHICLE_INQUIRY;

    return hasAllowedType && (event?.meta?.tradeInVehicle?.length > 0);
  }

  shouldShowDispatchTradeInText(event: CalendarEvent): boolean {
    const cardWidthPx = this.getDispatchCardWidthPx(event);
    const customerNameWidthPx = this.getEstimatedCustomerNameWidthPx(event);

    return cardWidthPx > customerNameWidthPx;
  }

  private getDispatchCardWidthPx(event: CalendarEvent): number {
    const metaCardWidth = event?.meta?.cardWidth;

    if (typeof metaCardWidth === 'number') {
      return metaCardWidth;
    }

    if (typeof metaCardWidth === 'string') {
      const parsed = parseFloat(metaCardWidth);
      if (!Number.isNaN(parsed)) {
        return parsed;
      }
    }

    return this.minimumDispatchCardWidth;
  }

  getCustomerDisplayName(appointment: { customer?: any }): string {
    return util.getCustomerDisplayName(appointment?.customer);
  }

  private getEstimatedCustomerNameWidthPx(event: CalendarEvent): number {
    const customerName = this.getCustomerDisplayName(event?.meta || {}).toString();

    return customerName.length * this.dispatchNameCharWidthPx;
  }

  ngOnDestroy(): void {
    util.unsubscribeSubscriptions(this.subs);
  }

  isDragAccessAllowed(appointmentType) {
    if (appointmentType === AppointmentType.SERVICE) {
      return !util.isServiceAccessibleFeatureFlag ?  !util.isSpServiceDashboardOverride : true;
    }
    else if (appointmentType === AppointmentType.LEARNING || appointmentType === AppointmentType.TEST_DRIVE || appointmentType === AppointmentType.DELIVERY || appointmentType === AppointmentType.VEHICLE_INQUIRY) {
      return !!util.isSalesAccessibleFeatureFlag;
    }
    else {
      return true;
    }
  }

  fetchAppointmentFromHistory(){
    
  }
}
